import React from 'react';
import HalfCircleIcon from '@smart-tv/components/icons/half-circle';


interface Props extends React.HTMLAttributes<HTMLDivElement> {
  width?: number;
  height?: number;
}

export const NorlysCircleIcon: React.FC<Props> = (props: Props) => {
  const { width = 16, height = 36, style, ...rest } = props;

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} {...rest}>
      <HalfCircleIcon mirror={false} width={width} height={height} style={{ marginRight: '4px', ...style }} />
      <HalfCircleIcon mirror={true} width={width} height={height} style={style} />
    </div>
  );
};  

export default NorlysCircleIcon;
